module.exports = __webpack_public_path__ + "static/childcouncil_card_img4@2x-4ee4d42f3131af3435e29045659fd875.jpg";